import React from "react"
import style from "./ticker.mod.scss"
import { Button } from "@components"
import { useStaticQuery, graphql } from "gatsby"
import SwiperCore, { Autoplay } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import { FaAngleRight } from "@react-icons/all-files/fa/FaAngleRight"
import {
  filterByLocale,
  filterByCountry,
  promoChecker
} from "@helpers/miscHelpers"

SwiperCore.use([Autoplay])

const Ticker = () => {
  const data = useStaticQuery(graphql`
    query TickerQuery {
      auGlobal: datoCmsGlobal(locale: "en-AU") {
        ticker {
          ...Link
        }
        tickerButton {
          ...Link
        }
      }
      nzGlobal: datoCmsGlobal(locale: "en-NZ") {
        ticker {
          ...Link
        }
        tickerButton {
          ...Link
        }
      }

      promotions: allDatoCmsPromotion {
        nodes {
          id
          country
          tickerText
          locales
          startDate
          endDate
          pageLink {
            ... on DatoCmsPage {
              id
              path
            }
            ... on DatoCmsCollection {
              id
              path
            }
          }
        }
      }
    }
  `)
  // The global record holds a ticker for each locale. Copy it, as promo
  // tickers are added to the front below.
  const siteLanguage = process.env.GATSBY_LANGUAGE || "en-AU"
  const localeGlobal = siteLanguage === "en-AU" ? data.auGlobal : data.nzGlobal
  const promos = filterByCountry(filterByLocale(data.promotions.nodes))
  const tickerLinks = [...(localeGlobal?.ticker || [])]
  const promoTickers = promos.map(promo => {
    if (promoChecker(promo.startDate, promo.endDate, promo.locales))
      return {
        id: promo.id,
        displayText: promo.tickerText,
        link: promo.pageLink ? { path: promo.pageLink.path } : null
      }
    else return null
  })
  promoTickers && tickerLinks.unshift(...promoTickers.filter(Boolean))

  // The CTA defaults to Get a Quote unless a ticker button is set on Global.
  const tickerButton = localeGlobal?.tickerButton
  const cta = tickerButton
    ? {
        text: tickerButton.displayText,
        to: tickerButton.link?.path || tickerButton.url,
        gaTarget: "ticker-button"
      }
    : {
        text: "Get a Quote",
        to: "/contact-us/get-a-quote/",
        gaTarget: "ticker-get-a-quote-button"
      }

  const config = {
    modules: [Autoplay],
    direction: "vertical",
    autoplay: {
      delay: 6000
    },
    loop: true,
    speed: 400,
    updateOnWindowResize: false
  }

  return (
    <div className={style.ticker}>
      <div className={style.ticker__top}>
        <Button
          gaTarget={cta.gaTarget.replace("ticker-", "ticker-mobile-")}
          children={cta.text}
          to={cta.to}
          secondary
          white
          short
          wide
        />
      </div>
      <div className={style.ticker__bottom}>
        <div className={style.ticker__inner}>
          <Swiper {...config}>
            {tickerLinks &&
              tickerLinks.length > 0 &&
              tickerLinks.map(({ id, displayText, link, url }) => {
                return (
                  <SwiperSlide
                    key={`ticker-link-${id}`}
                    className={style.ticker__link}
                  >
                    <Button
                      gaTarget={"ticker-link"}
                      children={config.children}
                      to={link && link.path ? link.path : url}
                      unstyled
                    >
                      <h3>{displayText}</h3>
                      <FaAngleRight className={style["ticker__icon"]} />
                    </Button>
                  </SwiperSlide>
                )
              })}
          </Swiper>
          <div className={style.ticker__cta}>
            <Button
              gaTarget={cta.gaTarget}
              children={cta.text}
              to={cta.to}
              secondary
              white
              short
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Ticker
